import React from "react";
import {useSelector} from "react-redux";
import PhoneConfirmModal from "./PhoneConfirmModal";
import PhoneConfirmError from "./PhoneConfirmError";
import PhoneConfirmSuccess from "./PhoneConfirmSuccess";

const ConfirmCredentials = () => {
    const user_profile = useSelector((state) => state.myAccountReducer.user_profile);
    const show_sms_validation =  useSelector((state) => state.myAccountReducer.show_sms_validation);
    const sms_code_state =  useSelector((state) => state.myAccountReducer.sms_code_state);
    const sms_code_state_message =  useSelector((state) => state.myAccountReducer.sms_code_state_message);

    if(show_sms_validation){
        return (
            <PhoneConfirmModal
                user_profile={user_profile}
            />
        )
    }

    if(sms_code_state === 1){
        return (
            <PhoneConfirmError
                sms_code_state_message={sms_code_state_message}
            />
        )
    }
    if(sms_code_state > 1){
        return (
            <PhoneConfirmSuccess
                user_profile={user_profile}
                sms_code_state={sms_code_state}
            />
        )
    }

    return null;
}

export default ConfirmCredentials;